import React from "react";
import { useTheme } from "../context/ThemeContext";

export default function ImportJobStepper({ steps, currentIndex }) {
  const { colors } = useTheme();
  const list = Array.isArray(steps) ? steps : [];

  return (
    <ol className="flex items-start justify-between gap-2 w-full">
      {list.map((label, index) => {
        const active = index === currentIndex;
        const done = index < currentIndex;
        return (
          <li
            key={`${label}-${index}`}
            className="flex flex-1 min-w-0 flex-col items-center relative"
          >
            {index < list.length - 1 && (
              <span
                className="absolute top-4 left-[calc(50%+16px)] right-[calc(-50%+16px)] h-px"
                style={{ backgroundColor: colors.border }}
              />
            )}
            <span
              className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold text-white"
              style={{
                backgroundImage: active || done ? colors.gradient : undefined,
                backgroundColor: active || done ? undefined : colors.border,
                boxShadow: active ? `0 0 16px ${colors.primary}55` : "none",
              }}
            >
              {index + 1}
            </span>
            <span
              className="mt-2 text-center text-xs font-medium px-1"
              style={{
                color: active ? colors.text : colors.textSecondary,
              }}
            >
              {label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
